<body style="background-color: #F0F0F4;  overflow-y: hidden;">

    <div class="main-wrapper">
        <div class="main-content">
            <header>
    
                <div class="head-line">
    
                    <p>Company</p>
                    
    
                </div>
                <div class="user-wrapper">
                    <p>{{storedData.agencyRefId.agencyName}}</p>
    
                    <div>
                        <img class="log1" [src]="this.storedData.agencyRefId.logo?this.storedData.agencyRefId.logo:'../../../../assets/../../assets/images/user1.jpeg'">
                    </div>
                </div>
            </header>
            <main class="main-2">
    
                <!-- <div class="container"> -->
  <div class="marketing-admin-wrapper" style="display: flex;">
      <!-- <div class="leftpannel" style="width: 183px;background: #181818; height: 98vh; overflow-y: hidden; border-radius: 15px;"></div> -->
      <div class="rightpannel" style="width: 100%; margin: 0 15px;">
            
          <!-- COPY CODE FROM HERE -->
           <div class="mdb-main-wrapper">
              <!-- ****** -->
              <div class="mdb-card-wrapper">
                <form [formGroup]="performanceForm">
                  <div class="mdb-card-titile">Performance</div>
                  <div class="mdb-filter-wrapper">
                      <div class="mdb-filter-input-wrapper">
                          <div class="mdb-filter-label">Usertype</div>
                          <select formControlName="userType"  (change)="perfomanceDashboard()">
                            <option *ngFor="let option of  userTypes" [ngValue]="option">{{ option.userType }}</option>
                          </select>
                      </div>
                      <div class="mdb-filter-input-wrapper">
                          <div class="mdb-filter-label">Category</div>
                          <select formControlName="status"  (change)="perfomanceDashboard()">
                            <option *ngIf="performanceForm.value.userType.userType === 'Backend Staff'||performanceForm.value.userType.userType === 'Field Executive'" [ngValue]="'initiated'">Initiated</option>
                            <option *ngIf="performanceForm.value.userType.userType === 'Backend Staff'" [ngValue]="'Verified'">Verified</option>

                            <option *ngIf="performanceForm.value.userType.userType === 'Tele Caller'" [ngValue]="'interested'">Interested</option>
                            <option *ngIf="performanceForm.value.userType.userType === 'Tele Caller'" [ngValue]="'telecall'">Tele Call</option>

                          </select>
                      </div>
                      <div class="mdb-filter-input-wrapper">
                          <div class="mdb-filter-label">Date</div>
                          <!-- paste datepicker already used in this project -->
                          <input type="date" formControlName="date"  (change)="perfomanceDashboard()">
                          <!---->
                      </div>
                  </div>
                  <div class="mdb-table-wrapper">
                      <table>
                          <thead>
                              <!-- <th class="tbl-left">Usertype</th> -->
                              <th class="tbl-left">Name</th>
                              <th class="tbl-left">PunchIn</th>
                              <th class="tbl-left">PunchOut</th>
                              <th>Before 8AM</th>
                              <th>8AM</th>
                              <th>9AM</th>
                              <th>10AM</th>
                              <th>11AM</th>
                              <th>12PM</th>
                              <th>1PM</th>
                              <th>2PM</th>
                              <th>3PM</th>
                              <th>4PM</th>
                              <th>5PM</th>
                              <th>6PM</th>
                              <th>7PM</th>
                              <th>After 7PM</th>
                              <th>Total</th>
                          </thead>
                          <tbody>
                              <tr *ngFor="let each of  perfomanceData" >
                                  <!-- <td class="tbl-left">{{each.staffname}}</td> -->
                                  <td class="tbl-left">{{each.staffname}}</td>
                                  <td class="tbl-left">
                                    <span [ngClass]="each.punchin === 'NA' ? 'mdbtbl-notpuchedin-status' : ''">
                                      {{ each.punchin === 'NA' ? 'Not Punched In' : each.punchin }}
                                  </span></td>
                                  <td class="tbl-left">  {{ each.punchout}}</td>
                                  <td [ngClass]="{'bold': each.before !== 0}">{{ each.before }}</td>
                                  <td [ngClass]="{'bold': each[8] !== 0}">{{ each[8] }}</td> 
                                  <td [ngClass]="{'bold': each[9] !== 0}">{{ each[9] }}</td>
                                  <td [ngClass]="{'bold': each[10] !== 0}">{{ each[10] }}</td>
                                  <td [ngClass]="{'bold': each[11] !== 0}">{{ each[11] }}</td>
                                  <td [ngClass]="{'bold': each[12] !== 0}">{{ each[12] }}</td>
                                  <td [ngClass]="{'bold': each[1] !== 0}">{{ each[1] }}</td>
                                  <td [ngClass]="{'bold': each[2] !== 0}">{{ each[2] }}</td>
                                  <td [ngClass]="{'bold': each[3] !== 0}">{{ each[3] }}</td>
                                  <td [ngClass]="{'bold': each[4] !== 0}">{{ each[4] }}</td>
                                  <td [ngClass]="{'bold': each[5] !== 0}">{{ each[5] }}</td>
                                  <td [ngClass]="{'bold': each[6] !== 0}">{{ each[6] }}</td>
                                  <td [ngClass]="{'bold': each[7] !== 0}">{{ each[7] }}</td> 
                                  <td [ngClass]="{'bold': each.after !== 0}">{{ each.after }}</td>
                                  <td [ngClass]="{'bold': each.total !== 0}">{{ each.total }}</td>
                                  
                              </tr>
                            
                          </tbody>
                      </table>
                  </div>
                </form>
              </div>
              <div class="mdb-card-gap"></div>
              <!-- ****** -->
               <div class="mdb-flex-wrapper">
                  <div class="mdb-card-wrapper">
                      <div class="mdb-card-titile">Live Case Count</div>
                      <form [formGroup]="LiveCaseForm">
                      <div class="mdb-filter-wrapper-one">
                          <div class="mdb-filter-input-wrapper">
                              <select formControlName="status"  (change)="liveCaseCout()">
                                  <option value="Under Validation">Under Validation</option>
                                  <option value="Under TeleCall">Under TeleCall</option>
                                  <option value="Interested">Interested</option>
                                  <option value="Field Visit">Meeting Case</option>

                              </select>
                          </div>
                      </div>
                      <div class="mbd-card-graph-wrapper">
                        <canvas baseChart 
                        [data]="barChartData"
                        [options]="barChartOptions"
                      >
                      </canvas>                      </div>
                      <div class="mdb-table-wrapper">
                        <table>
                            <thead>
                                <th class="tbl-left">Name</th>
                                <th class="tbl-left">Case Count</th>
                               
                            </thead>
                            <tbody>
                                <tr *ngFor="let each of  liveCaseData" >
                                  <td class="tbl-left">{{each.name}}</td>

                                    <td class="tbl-left">{{each.caseCount}}</td>
                                  </tr>
                              
                            </tbody>
                        </table>
                    </div>
                 
                   </form>
                   </div>
                   <!-- <div class="mdb-card-wrapper">
                      <div class="mdb-card-titile">Inetersted Case</div>
                      <div class="mdb-card-spacer"></div>
                      <div class="mbd-card-graph-wrapper">
                          <img src="chart2.png" style="width: 100%; display: block;" alt="">
                      </div>
                   </div> -->
                   <div class="mdb-card-wrapper" style="margin-left: -8px;">
                    <div class="mdb-card-titile">Interested Count</div>
                   
                    <div class="mdb-filter-wrapper">
                      <div class="mdb-filter-input-wrapper">
                          <!-- <div class="mdb-filter-label">Status</div> -->
                         <input type="month"  (change)="interestedCases()" [ngModelOptions]="{standalone: true}" [(ngModel)]="InterestedMonth" (change)="productCases()" >
                      </div>
                      </div>
  
                      <div class="mbd-card-graph-wrapper">
                        <canvas baseChart 
                        [data]="braChart2Data"
                        [options]="braChart2Options"
                      >
                      </canvas>                      </div>
                      <div class="mdb-table-wrapper">
                        <table>
                            <thead>
                              <th class="tbl-left">UserName</th>
  
                                <th class="tbl-left">Interested Case Count</th>
                                <th class="tbl-left">Field Case Count</th>
                                <th class="tbl-left">Enrolled Case Count</th>
                            </thead>
                            <tbody>
                                <tr *ngFor="let each of  InterestedCaseData let i=index" >
                                    <td class="tbl-left">{{each.name}}</td>
                                    <td class="tbl-left">{{each.Interested}}</td>
                                    <td class="tbl-left">{{each['Field Visit']}}</td>
                                    <td class="tbl-left">{{each['Client Enrolled']}}</td>
  
                                    
                                </tr>
                               
                            </tbody>
                        </table>
                        
                    </div>
                 
                 </div>
                   
               </div>
               
               <div class="mdb-card-gap"></div>
               <!-- ****** -->
               <div class="mdb-card-wrapper">
                <form  [formGroup]="reminderForm">

                  <div class="mdb-card-titile">Reminder Cases</div>
                  <div class="mdb-filter-wrapper">
                      <div class="mdb-filter-input-wrapper">
                          <div class="mdb-filter-label">Status</div>
                          <select formControlName="status"  (change)="reminderCases()">
                            <option value="Under Validation">Under Validation</option>
                            <option value="Under TeleCall">Under TeleCall</option>
                            <option value="Interested">Interested</option>
                            <option value="Field Visit">Meeting Case</option>

                        </select>
                      </div>
                      <div class="mdb-filter-input-wrapper">
                          <div class="mdb-filter-label">Product</div>
                          <select formControlName="product" (change)="reminderCases()">
                            <option *ngFor="let option of  productDetails" [ngValue]="option">{{ option.name }}</option>

                          </select>
                      </div>
                      <div class="mdb-filter-input-wrapper">
                          <div class="mdb-filter-label">Date</div>
                          <!-- paste datepicker already used in this project -->
                          <input type="date" formControlName="date" (change)="reminderCases()">
                          <!---->
                      </div>
                      <div class="mdb-filter-input-wrapper">
                        <div class="mdb-filter-label">Count</div>
                      <select formControlName="rows"  (change)="reminderCases()">
                        <option value="10">10</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="150">150</option>
                        <option value="1000">1000</option>
                    </select>
                    </div>
                    
                  </div>
                  <div class="mdb-table-wrapper">
                      <table>
                          <thead>
                              <th class="tbl-left">No</th>
                              <!-- <th class="tbl-left">Date</th> -->
                              <th class="tbl-left">Company</th>
                              <th class="tbl-left">Product</th>
                              <th>Backend Satff</th>
                              <th>Tele Call </th>
                              <th>Reminder By</th>
                              <th>Reminder To</th>
                              <th>Reminder Date</th>
                              <!-- <th>12PM</th>
                              <th>1PM</th>
                              <th>2PM</th>
                              <th>3PM</th>
                              <th>4PM</th>
                              <th>5PM</th>
                              <th>6PM</th>
                              <th>7PM</th>
                              <th>After 7PM</th>
                              <th>8PM</th> -->
                          </thead>
                          <tbody>
                              <tr *ngFor="let each of  reminderCaseData.slice(0, this.reminderForm.value.rows) let i=index" >
                                  <td class="tbl-left">{{i+1}}</td>
                                  <!-- <td class="tbl-left">{{each.date}}</td> -->
                                  <td class="tbl-left">{{each.clientName}}</td>
                                  <td class="tbl-left">{{reminderForm.value.product.name}}</td>
                                  <td>{{each.allocatedTo?.name || ''}}</td>
                                  <td>{{each.teleCallerId?.name || ''}}</td>
                                  <td>{{each.reminder.reminderSetBy?.name ||''}}</td>
                                  <td>{{each.reminder.reminderAllocatedTo?.name ||''}} </td>

                                  <td>{{format(each.reminderDate)}}</td>
                                  <!-- <td>{{reminderForm.value.product}}</td> -->
                                  
                              </tr>
                             
                          </tbody>
                      </table>
                      
                  </div>
</form>
                </div>
              <div class="mdb-card-gap"></div>
               <!-- ****** -->
               <div class="mdb-card-wrapper">
                  <div class="mdb-card-titile">Product Dashboard</div>

                  <div class="mdb-filter-wrapper">
                    <div class="mdb-filter-input-wrapper">
                        <div class="mdb-filter-label">Status</div>
                       <input type="month" [ngModelOptions]="{standalone: true}" [(ngModel)]="ProductMonth" (change)="productCases()" >
                    </div>
                    </div>


                    <div class="mdb-table-wrapper">
                      <table>
                          <thead>
                            <th class="tbl-left">Name</th>

                              <th class="tbl-left">Interested Case Count</th>
                              <th class="tbl-left">Field Case Count</th>
                              <th class="tbl-left">Enrolled Case Count</th>
                          </thead>
                          <tbody>
                              <tr *ngFor="let each of  ProductCaseData let i=index" >
                                  <td class="tbl-left">{{each.name}}</td>
                                  <td class="tbl-left">{{each.Interested}}</td>
                                  <td class="tbl-left">{{each['Field Visit']}}</td>
                                  <td class="tbl-left">{{each['Client Enrolled']}}</td>

                                  
                              </tr>
                             
                          </tbody>
                      </table>
                      
                  </div>

                  <!-- <div class="mdb-chart-wrapper3">
                      <img src="chart3.png" style="display: block; height: 270px;" alt="">
                  </div> -->
              </div>
              <div class="mdb-card-gap"></div>
              <!-- ****** -->
           </div>
          <!-- COPY CODE TILL HERE -->

      </div>
  </div>
  <!-- </div> -->
  </main>
  </div>
  </div>
</body>